import { trackEvent } from "./ga-events";
import { attachPlaceTypeahead } from "./concierge-typeahead";

/* Activity Concierge — authenticated in-app module (iteration 2).
   An embedded form (not the anonymous CDN overlay) on a signed-in Family HQ page. AJAX-submits to
   /activity-concierge/member/submit (antiforgery token rides along in the FormData). The endpoint skips the
   confirm gate (email already verified) and enqueues directly; responses are { success, status, message }. */
(function () {
  "use strict";

  var root = document.querySelector("[data-fhq-concierge-member]");
  if (!root || root.dataset.initialized === "true") return;
  root.dataset.initialized = "true";

  var form = root.querySelector("[data-fhq-concierge-member-form]");
  if (!form) return;
  var statusEl = root.querySelector("[data-fhq-concierge-member-status]");
  var donePanel = root.querySelector("[data-fhq-concierge-member-done]");
  var doneText = root.querySelector("[data-fhq-concierge-member-done-text]");
  var againBtn = root.querySelector("[data-fhq-concierge-member-again]");
  var submitBtn = root.querySelector("[data-fhq-concierge-member-submit]");
  var quotaEl = root.querySelector("[data-fhq-concierge-member-quota]");
  var remainingEl = root.querySelector("[data-fhq-concierge-member-remaining]");

  function setStatus(msg) { if (statusEl) statusEl.textContent = msg || ""; }

  // Refresh the "You have N of M left" line after a successful submit — the quota is rendered at page load,
  // and this fetch-based form never reloads, so without this the count looks unchanged (e.g. stuck at 5/5).
  function updateRemaining(remaining) {
    if (typeof remaining !== "number") return;
    if (remainingEl) remainingEl.textContent = String(Math.max(0, remaining));
    if (quotaEl) {
      quotaEl.classList.toggle("fhq-cm__quota--low", remaining === 1);
      quotaEl.classList.toggle("fhq-cm__quota--empty", remaining <= 0);
    }
  }

  // The reset date ("July 1") is rendered server-side on the quota line; the response also carries it as a fallback.
  function resetLabel(data) {
    if (data && typeof data.reset === "string" && data.reset) return data.reset;
    return quotaEl ? quotaEl.getAttribute("data-fhq-concierge-member-reset") : null;
  }

  // Location typeahead (city/ZIP autocomplete from the bundled dataset); a selection also fills the ZIP field.
  attachPlaceTypeahead(form.querySelector("#fhq-cm-location"), { zipInput: form.querySelector("#fhq-cm-zip") });

  // Kid-ages reveal (mirrors the anonymous wizard).
  var kidsWrap = root.querySelector("[data-fhq-concierge-kids]");
  var kidsToggle = root.querySelector("[data-fhq-concierge-kids-toggle]");
  root.querySelectorAll("input[name='Audience']").forEach(function (radio) {
    radio.addEventListener("change", function () {
      if (kidsWrap && kidsToggle) kidsWrap.hidden = !kidsToggle.checked;
    });
  });

  // "Plan another list" — return to the form (inputs kept, so the user can tweak rather than restart).
  if (againBtn) {
    againBtn.addEventListener("click", function () {
      if (donePanel) donePanel.hidden = true;
      if (form) form.hidden = false;
      if (submitBtn) submitBtn.disabled = false;
      setStatus("");
      var locationInput = form.querySelector("[name='Location']");
      if (locationInput) locationInput.focus();
      if (form && form.scrollIntoView) form.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var location = form.querySelector("[name='Location']");
    if (location && location.value.trim() === "") {
      setStatus("Enter a city or area.");
      location.focus();
      return;
    }

    if (submitBtn) submitBtn.disabled = true;
    setStatus("Building your list…");

    fetch(form.getAttribute("action") || "/activity-concierge/member/submit", {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: new FormData(form),
      credentials: "same-origin"
    })
      .then(function (r) { return r.json().catch(function () { return {}; }); })
      .then(function (data) {
        if (data && data.success) {
          trackEvent("concierge_member_submit", { source: "familyhq-app" });
          updateRemaining(data.remaining);
          var spent = typeof data.remaining === "number" && data.remaining <= 0;
          var doneMsg = "We'll email it to you in a few minutes.";
          if (spent) {
            var rl = resetLabel(data);
            doneMsg += rl
              ? " That was your last list this month — your limit refreshes on " + rl + "."
              : " That was your last list this month.";
          }
          if (doneText) doneText.textContent = doneMsg;
          if (againBtn) againBtn.hidden = spent; // no point offering "plan another" with nothing left
          if (form) form.hidden = true;
          if (donePanel) donePanel.hidden = false;
        } else if (data && data.status === "quota") {
          // Already at the cap (e.g. a second tab) — no point letting them retry into the same wall.
          updateRemaining(0);
          var qrl = resetLabel(data);
          setStatus("You've used all your activity lists this month." + (qrl ? " Your limit refreshes on " + qrl + "." : ""));
          if (submitBtn) submitBtn.disabled = true;
        } else {
          if (submitBtn) submitBtn.disabled = false;
          setStatus((data && data.message) || "Something went wrong. Please try again.");
        }
      })
      .catch(function () {
        if (submitBtn) submitBtn.disabled = false;
        setStatus("Network error. Please try again.");
      });
  });
})();
